/*
 * @Description: computer mutations type
 */
export enum ComputerMutationTypes {
  //导航
  SET_NAV_CONFIG = 'SET_NAV_CONFIG',
  ADD_NAV_CONFIG_LIST = 'ADD_NAV_CONFIG_LIST',
  DEL_NAV_CONFIG_LIST = 'DEL_NAV_CONFIG_LIST',
  MODIFY_NAV_CONFIG_LIST = 'MODIFY_NAV_CONFIG_LIST',
  //页脚
  SET_FOOTER_CONFIG = 'SET_FOOTER_CONFIG',
  //页面配置
  PC_MODIFY_PAGE_CONFIG = 'PC_MODIFY_PAGE_CONFIG', 
  
  //预览保存
  SUBMIT_AND_PREVIEW_PAGE = 'SUBMIT_AND_PREVIEW_PAGE'
}